import { render, staticRenderFns } from "./AdminIcons.vue?vue&type=template&id=627a70f6&scoped=true"
import script from "./AdminIcons.vue?vue&type=script&lang=js"
export * from "./AdminIcons.vue?vue&type=script&lang=js"
import style0 from "./AdminIcons.vue?vue&type=style&index=0&id=627a70f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a70f6",
  null
  
)

export default component.exports